const getFileUiLabels = () => {
  const localized =
    typeof themeInterneFileInputs === "object" &&
    themeInterneFileInputs !== null &&
    typeof themeInterneFileInputs.emptyFileLabel === "string" &&
    typeof themeInterneFileInputs.chooseFileLabel === "string";

  if (localized) {
    return {
      empty: themeInterneFileInputs.emptyFileLabel,
      choose: themeInterneFileInputs.chooseFileLabel,
    };
  }

  return {
    empty: "No file chosen",
    choose: "Choose file",
  };
};

let cf7FileResetBound = false;

const resetPlainFileUi = (input) => {
  const wrap = input.closest(".wpcf7-form-control-wrap");
  if (!wrap?.dataset.themeInterneFileUi) return;
  const nameEl = wrap.querySelector(".file-field__filename");
  if (nameEl) nameEl.textContent = getFileUiLabels().empty;
};

const bindCf7PlainFileReset = () => {
  if (cf7FileResetBound) return;
  cf7FileResetBound = true;

  document.addEventListener("wpcf7mailsent", (e) => {
    const form = e.target;
    if (!form?.matches?.("form.wpcf7-form")) return;
    form.querySelectorAll("input.wpcf7-file").forEach(resetPlainFileUi);
  });

  document.addEventListener("wpcf7reset", (e) => {
    const form = e.target;
    if (!form?.matches?.("form.wpcf7-form")) return;
    form.querySelectorAll("input.wpcf7-file").forEach(resetPlainFileUi);
  });
};

const initPlainFileField = (input) => {
  const wrap = input.closest(".wpcf7-form-control-wrap");
  if (!wrap || wrap.dataset.themeInterneFileUi) return;

  wrap.dataset.themeInterneFileUi = "1";
  wrap.classList.add("file-field");

  const row = document.createElement("span");
  row.className = "file-field__row";

  const labels = getFileUiLabels();

  const button = document.createElement("button");
  button.type = "button";
  button.className = "file-field__button";
  button.textContent = labels.choose;
  button.setAttribute("aria-label", labels.choose);

  const nameSpan = document.createElement("span");
  nameSpan.className = "file-field__filename";
  nameSpan.setAttribute("aria-live", "polite");
  nameSpan.textContent = labels.empty;

  wrap.insertBefore(row, input);
  row.append(button, nameSpan, input);

  const updateName = () => {
    const file = input.files?.[0];
    nameSpan.textContent = file ? file.name : labels.empty;
  };

  button.addEventListener("click", () => input.click());
  input.addEventListener("change", updateName);
};

export const initFileInputs = () => {
  bindCf7PlainFileReset();

  document
    .querySelectorAll(".wpcf7-form-control.wpcf7-file")
    .forEach((input) => {
      initPlainFileField(input);
    });
};
